import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Theme } from '@constants';

const { first, second, third, fourth } = Theme.gradients.settingsBackground;

export const SettingsBackground = ({ children }) => (
  <View
    style={[
      styles.radialGradient,
      {
        backgroundImage: `radial-gradient(closest-side at 50% 50%, ${first} 0%, ${second} 0%, ${third} 2%, ${fourth} 100%)`,
      },
    ]}
  >
    {children}
  </View>
);

const styles = StyleSheet.create({
  radialGradient: {
    flex: 1,
  },
});
